import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})

export class RoomDetailsService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

  getMaxId() :Observable <any[]>{
    return this.http.get<any[]>(`${this.env.apiUrl}/room-details/getMaxId`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

   getAll():Observable <any[]> {
    return this.http.get<any[]>(`${this.env.apiUrl}/room-details`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    addRoomDetails(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/room-details`,  data)
        .pipe(catchError(this.handleError));
       
    }


    updateRoomDetails(data):Observable <void>{
      return this.http.put<void>(`${this.env.apiUrl}/room-details`, data)
        .pipe(catchError(this.handleError));
       
    }

    deleteRoomDetails(id: string) : Observable <void>{
      return this.http.delete<void>(`${this.env.apiUrl}/room-details/${id}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }



}
